import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  forgotPasswordForm!: FormGroup;
  email = new FormControl('', [Validators.email, Validators.required]);
  submitted = false;
  linkGenerated = false;

  constructor(private adminServ: AdminService, private toast: ToastrService, private _fb: FormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.forgotPasswordForm = this._fb.group({
      email: ['', [Validators.email, Validators.required]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.forgotPasswordForm.valid) {
      this.adminServ.forgotPass(this.forgotPasswordForm.value).subscribe({
        next: res => {
          this.linkGenerated = true;
          this.toast.success(res.message);
        },
        error: err => this.toast.error(err.error.message)
      });
    }
  }

}
